// extracted by mini-css-extract-plugin
export default {"inactiveAppIcon":"inactiveAppIcon---IUAMc","error":"error---QKIwB","warn":"warn---y4vql","marginBottom0":"marginBottom0---Sfesy"};